@if (statusList) {
  <p-select
    (onChange)="onStatusChange($event)"
    [options]="statusList"
    [(ngModel)]="status"
    [placeholder]="status"
    [filter]="true"
    filterBy="label, value"
  >
  </p-select>
}
